import React, { useState } from 'react'
import emailjs from "emailjs-com";

import {ReactComponent as Email} from '../../assets/email.svg'
import {ReactComponent as Github} from '../../assets/github.svg'

const Contact = () => {

  const [nameValid, setNameValid] = useState('notused');
  const [emailValid, setEmailValid] = useState('notused');
  const [messageValid, setMessageValid] = useState(false);
  const [formValid, setFormValid] = useState(false);

  const [isSent, setIsSent] = useState(false);

  const handleNameChange = (e) => {
    (e.target.value.length > 6) ? setNameValid('true') : (e.target.value.length === 0) ? setNameValid('notused') : setNameValid('false');
    isFormValid();
  }
  
  const handleEmailChange = (e) => {
    (e.target.value.length > 6 && e.target.value.includes('@')) && e.target.value.slice(-1) !== '@' ? setEmailValid('true') : (e.target.value.length === 0) ? setEmailValid('notused') : setEmailValid('false');
    isFormValid();
  }

  const handleMessageChange = (e) => {
    (e.target.value.length >= 30) ? setMessageValid(true) : setMessageValid(false);
    isFormValid();
  }


  function sendEmail(e) {
    if(formValid) {
      emailjs
      .sendForm("service_2vv3sa7", "template_isd0q4e", e.target, "user_P8uNKO32eOanR3et8Hatz")
      .then(
          (result) => {
            document.getElementById('contact-form').reset();
            setNameValid('notused');
            setEmailValid('notused');
            setMessageValid(false);
            setIsSent(true);
          },
          (error) => {
            console.log(error.text);
          }
      );
    }
    e.preventDefault();
  }

  const isFormValid = () => {
    (nameValid === 'true' && emailValid === 'true' && messageValid) ? setFormValid(true) : setFormValid(false)
  }

  return (
    <section id="contact">
      <div className="content-wrapper container">
        <aside>
          <h2 className="title">Kontakt</h2>
          <a className="more" href="mailto:filipson20@gmail.com"><Email fill="#fff"/> filipson20@gmail.com</a>
          <a title="Github - Filip Krawczyk" rel="noopener noreferrer" target="_blank" href="https://github.com/fifcio13"><span className="sr-only">Profil na githubie</span><Github className="contact-icon"/></a>
        </aside>
        <div className="content">
          <form id="contact-form" onSubmit={sendEmail}>
            <div className="contact-data">
              <div className="inputfield">
                <label htmlFor="user_name">Imię i nazwisko</label>
                <input 
                  onChange={handleNameChange} 
                  className={nameValid === 'true' ? 'valid' : nameValid === 'notused' ? 'notused' : 'notvalid'}
                  type="text" 
                  minLength="6"
                  id="user_name" 
                  name="user_name" 
                  required 
                />
              </div>
              <div className="inputfield">
                <label htmlFor="user_email">Email</label>
                <input
                  onChange={handleEmailChange} 
                  className={emailValid === 'true' ? 'valid' : emailValid === 'notused' ? 'notused' : 'notvalid'}
                  type="email"
                  id="user_email"
                  name="user_email"
                  required
                />
              </div>
            </div>
            <div className="inputfield textareafield">
              <label htmlFor="message">Wiadomość</label>
              <textarea onChange={handleMessageChange} spellCheck="false" minLength="30" id="message" name="message" required />
            </div>
            <div className="status-wrapper">
              <input className={formValid ? 'active' : null} type="submit" value="Wyślij" />
              <div className="status">{isSent ? 'Wysłano wiadomość' : null}</div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact
